import { buildUrl } from '../../../../../../shared/frontend/libs/utils';
import { networkService } from '../../../../../../shared/frontend/scripts/services/networkService';

type NetworkBaseQueryArgs = {
  url: string;
  params?: Record<string, any>;
};

export const networkBaseQuery = async ({ url, params }: NetworkBaseQueryArgs) => {
  try {
    const fullUrl = params ? buildUrl(url, params) : url;
    const data = await networkService.get(fullUrl);
    return { data };
  } catch (error) {
    return { error };
  }
};
